import { strings } from "../i18n/strings.es-AR.js";
import { conversation, sending, phase } from "../state/store.js";
import { theme, toggleTheme } from "../hooks/useTheme.js";
import { Icon } from "./icons.jsx";

// Con abonado identificado se muestra su número; si no, el nombre si existe.
export function getAccountLabel({ clientName, clientId }) {
  return clientId ? strings.abonadoLabel(clientId) : clientName || null;
}

function StatusDot({ handoffActive }) {
  return (
    <span
      class={`inline-block h-2 w-2 shrink-0 rounded-full ${handoffActive ? "bg-flux-cyan" : "bg-flux-cyan-deep"}`}
    />
  );
}

// onOpenAccountMenu: el menú de la cuenta (y su confirmación) lo monta
// ChatScreen, no este header — `backdrop-blur` crea containing block y un
// `position: fixed` acá adentro se posicionaría contra la barra, no contra el viewport.
export function Header({ onOpenAccountMenu }) {
  const { handoffActive } = conversation.value;
  const accountLabel = getAccountLabel(conversation.value);

  return (
    <header class="border-b border-white/10 bg-white/10 px-4 py-3 backdrop-blur">
      <div class="chat-col flex items-center gap-3">
      {/* Isotipo decorativo (alt=""): el nombre ya lo dice el <h1> de al lado.
          La caja de color la pone el CSS (mismo #3347ec que el ícono de la PWA)
          y el PNG va con fondo transparente, así el logo se lee igual en tema
          claro y oscuro. */}
      <img
        src="/img/logo-x.png"
        alt=""
        width="36"
        height="36"
        class="h-9 w-9 shrink-0 rounded-xl bg-flux-primary p-1.5"
      />
      <div class="relative min-w-0 flex-1">
        <h1 class="truncate text-sm font-semibold text-white">{strings.headerTitle}</h1>
        {/* Con cuenta, la segunda línea la muestra y abre su menú (otra cuenta /
            cerrar sesión), como el encabezado de un contacto en WhatsApp: el
            `after:inset-0` estira el botón a todo el bloque del título. El punto
            sigue marcando bot/agente; el "Te atiende…" lo dice el banner de
            handoff. Sin cuenta no hay nada que cerrar: queda el estado. Ver
            closeSession(). */}
        {accountLabel ? (
          <button
            type="button"
            class="flex max-w-full items-center gap-1.5 text-xs text-flux-cyan after:absolute after:-inset-1 after:rounded-lg active:after:bg-white/10 disabled:opacity-40"
            disabled={sending.value || phase.value !== "ready"}
            onClick={onOpenAccountMenu}
            aria-haspopup="dialog"
            aria-label={`${accountLabel} · ${strings.accountMenu}`}
          >
            <StatusDot handoffActive={handoffActive} />
            <span class="truncate">{accountLabel}</span>
            <Icon name="chevron-down" size={14} class="shrink-0" />
          </button>
        ) : (
          <p class="flex items-center gap-1.5 text-xs text-white/70">
            <StatusDot handoffActive={handoffActive} />
            <span class="truncate">{handoffActive ? strings.headerSubtitleAgent : strings.headerSubtitleBot}</span>
          </p>
        )}
      </div>
      <button
        type="button"
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-white/80 active:bg-white/20"
        onClick={() => toggleTheme()}
        title={strings.toggleTheme}
        aria-label={strings.toggleTheme}
      >
        <Icon name={theme.value === "dark" ? "sun" : "moon"} size={17} />
      </button>
      </div>
    </header>
  );
}
